import { action } from '@reatom/framework'

import { pipe, Result } from '@blade/std-lib'
import { User } from '@root/entities/auth'
import { dependenciesAtom } from '@root/features/shared/dependencies'
import { apiRequest } from '@root/shared/api'

import type { GoogleAssignCreatePayload } from '@blade/trade-api-client'

export const isUserExistsGoogleRequestAction = action(
  async (ctx, req: GoogleAssignCreatePayload) => {
    const { tradeApiClient } = ctx.get(dependenciesAtom)

    const result = await ctx.schedule(() =>
      apiRequest(ctx, tradeApiClient.user.userIsExistsGoogleList, [req]),
    )

    return result
  },
  'isUserExistsGoogleRequestAction',
)

export const assignGoogleRequestAction = action(
  async (ctx, req: GoogleAssignCreatePayload) => {
    const {
      tradeApiClient,
      environment: { assets },
    } = ctx.get(dependenciesAtom)

    const result = await ctx.schedule(() =>
      apiRequest(ctx, tradeApiClient.google.googleAssignCreate, [req]),
    )

    return pipe(
      result,
      Result.map((dto) => User.fromDto(dto, assets.avatarsHost)),
    )
  },
  'assignGoogleRequestAction',
)

export const unassignGoogleRequestAction = action(async (ctx) => {
  const {
    tradeApiClient,
    environment: { assets },
  } = ctx.get(dependenciesAtom)

  const result = await ctx.schedule(() =>
    apiRequest(ctx, tradeApiClient.google.googleUnassignCreate, []),
  )

  return pipe(
    result,
    Result.map((dto) => User.fromDto(dto, assets.avatarsHost)),
  )
}, 'unassignGoogleRequestAction')
